import { useCallback, useState } from 'react';

import { hooks } from '@febos-io/common';
import { findOrdertList } from '../config';
import { OrderI } from '../types';

export function useDocumentOrdersListCallback(limit, sort) {
  const [elements, setElements] = useState<OrderI[]>([]);
  const [meta, setMeta] = useState({ total: 0, pages: 0 });

  const { callback, loading } = hooks.useRequestCallback(
    useCallback(
      async (request, filter, page) => {
        const {
          documentos = [],
          total,
          totalPages,
          totalPaginas,
          totalElementos
        } = await request.exec(findOrdertList(page, limit, sort, filter));
        setElements(documentos as OrderI[]);
        setMeta({ total: total || totalElementos, pages: totalPages || totalPaginas });
      },
      [limit, sort]
    )
  );

  return {
    loading,
    elements,
    meta,
    callback
  };
}

export default useDocumentOrdersListCallback;
